<template>
    <v-container class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col cols="12">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary secondary--text py-0"
                                  style="word-break: normal">TICKET Nº {{ id.length < 5 ? ('0000' + id).slice(-4) : id }}
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="6" align-self="stretch">
                <v-card height="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary secondary--text" style="word-break: normal">DETALLES
                        <v-btn outlined fab small class="float-right grey--text text--darken-2" @click="details = !details"
                               v-show="$vuetify.breakpoint.smAndDown">
                            <v-icon>{{details ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-divider/>
                    <v-card-subtitle v-show="$vuetify.breakpoint.smAndDown ? details : true" class="text-center pb-6">
                        <h3><strong>{{ ticketReferenceTitle }}</strong></h3>
                    </v-card-subtitle>
                    <v-card-text v-show="$vuetify.breakpoint.smAndDown ? details : true">
                        <v-row justify="center">
                            <v-col cols="6" class="py-0" v-if="user.role !== 'Customer'">
                                <h3 class="text-center"><strong>ID Cliente</strong></h3>
                                <p class="text-center">{{ claim.user_id }}</p>
                            </v-col>
                            <v-col cols="6" class="py-0">
                                <h3 class="text-center"><strong>País</strong></h3>
                                <p class="text-center">{{ claim.country }}</p>
                            </v-col>
                            <v-col cols="6" class="py-0">
                                <h3 class="text-center"><strong>Relación</strong></h3>
                                <p class="text-center">{{ claim.role }}</p>
                            </v-col>
                            <v-col cols="6" class="py-0">
                                <h3 class="text-center"><strong>Teléfono</strong></h3>
                                <p class="text-center">{{ claim.phone }}</p>
                            </v-col>
                            <v-col cols="6" class="py-0">
                                <h3 class="text-center"><strong>Estado</strong></h3>
                                <p class="text-center">{{ ticketStatusText }}</p>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <h3 class="text-center"><strong>Area</strong></h3>
                                <p class="text-center">{{ moduleLabel(claim.pay_form) }}</p>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <h3 class="text-center"><strong>Referencia</strong></h3>
                                <p class="text-center">{{ ticketReferenceText }}</p>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <h3 class="text-center"><strong>Fecha de Creación</strong></h3>
                                <p class="text-center">{{ claim.created_at }}</p>
                            </v-col>
                            <v-col cols="12" class="py-0">
                                <h3 class="text-center"><strong>Motivo</strong></h3>
                                <p class="text-center">{{ claim.reason }}</p>
                            </v-col>
                            <v-col cols="12" class="py-6 text-center" v-if="user.role !== 'Customer'">
                                <v-btn color="error" dark elevation="0" @click="openClaim(claim.id)" v-if="claim.status === 303">
                                    <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Reabrir Ticket
                                </v-btn>
                                <v-btn color="error" dark elevation="0" @click="closeClaim(claim.id)" v-else>
                                    <v-icon>mdi-close-circle</v-icon>&nbsp;&nbsp;Cerrar Ticket
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" align-self="stretch">
                <v-card height="100%" class="ticket-chat-card">
                    <v-card-title class="primary secondary--text ticket-chat-header" style="word-break: normal">
                        <v-icon color="secondary" class="mr-2">mdi-message-text</v-icon>
                        <span class="font-weight-bold">MENSAJES</span>
                        <v-spacer/>
                        <v-btn icon color="secondary" :loading="loading" @click="getClaim">
                            <v-icon>mdi-sync</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-divider/>
                    <v-card-text ref="messageList" class="ticket-chat-body" v-chat-scroll>
                        <template v-for="msg in messages">
                            <div :key="msg.id" class="ticket-message-row" :class="messageRowClass(msg)">
                                <v-avatar class="ticket-message-avatar" size="40">
                                    <img src="/img/cliente.jpg" :alt="msg.name" v-if="msg.role === 'Customer'">
                                    <img src="/img/soporte.jpg" :alt="msg.name" v-else>
                                </v-avatar>
                                <div class="ticket-message-content">
                                    <div class="ticket-message-meta caption">
                                        <v-icon size="16" v-if="msg.role !== 'Customer'">mdi-face-agent</v-icon>
                                        {{ senderLabel(msg) }} · {{ msg.created_at }}
                                    </div>
                                    <v-img
                                        :src="'/' + msg.text"
                                        alt="Vista Previa"
                                        @click="getImg(msg.id)"
                                        max-height="180px"
                                        max-width="100%"
                                        contain
                                        class="ticket-message-image"
                                        v-if="msg.type === 'Img'"/>
                                    <div class="ticket-bubble" :class="messageBubbleClass(msg)" v-else>
                                        {{ msg.text }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-card-text>
                    <v-divider v-if="claim.status === 301 || claim.status === 302"/>
                    <v-card-actions class="ticket-chat-composer" v-if="claim.status === 301 || claim.status === 302">
                        <v-form ref="form" @submit.prevent="sendMessage(1)" lazy-validation v-model="valid" class="ticket-form">
                            <div class="ticket-composer-row">
                                <v-btn icon color="primary" :disabled="loading" @click="$refs.uploader.click()">
                                    <v-icon>mdi-camera</v-icon>
                                </v-btn>
                                <v-menu v-model="emojiMenu" top offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon color="primary" :disabled="loading" v-bind="attrs" v-on="on">
                                            <v-icon>mdi-emoticon-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card class="pa-2 emoji-picker">
                                        <v-btn
                                            v-for="emoji in emojis"
                                            :key="emoji"
                                            icon
                                            small
                                            class="ma-1"
                                            @click="appendEmoji(emoji)">
                                            <span class="emoji-option">{{ emoji }}</span>
                                        </v-btn>
                                    </v-card>
                                </v-menu>
                                <v-textarea
                                    :label="labels.message"
                                    name="message"
                                    counter="1000"
                                    v-model="form.message"
                                    placeholder="Escribe un mensaje"
                                    rows="1"
                                    auto-grow
                                    filled
                                    dense
                                    hide-details="auto"
                                    clearable
                                    :disabled="loading"
                                    :loading="loading"
                                    :error-messages="errors.message"
                                    :rules="[rules.min('message', 1, 'La'), rules.max('message', 1000, 'La')]"
                                    @input="clearErrors('message')"
                                    @keydown.enter.exact.prevent="sendMessage(1)"
                                    clear-icon="mdi-close-circle"
                                    @click:clear="clearMessage"/>
                                <v-btn
                                    fab
                                    small
                                    color="primary"
                                    class="secondary--text"
                                    :loading="loading"
                                    :disabled="loading || !canSendText"
                                    @click="sendMessage(1)">
                                    <v-icon>mdi-send</v-icon>
                                </v-btn>
                            </div>
                        </v-form>
                        <input ref="uploader" class="d-none" type="file" accept="image/*" @change="onFileChanged">
                    </v-card-actions>
                </v-card>
                <v-dialog v-model="view" fullscreen>
                    <v-card color="card">
                        <v-toolbar dark color="primary" class="px-2">
                            <v-btn icon large @click="closeImg" class="bg primary--text">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title class="d-inline-block text-center font-weight-medium pl-0" style="white-space:normal;width:100%">Vista Previa</v-toolbar-title>
                            <div class="flex-grow-1"></div>
                            <v-btn icon large @click="sendMessage(2)" class="bg primary--text" v-if="form.img !== null">
                                <v-icon>mdi-send</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text class="px-0">
                            <v-img :src="img" alt="Vista Previa" max-height="700px" max-width="100%" contain/>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Form from "../helpers/form";

    export default {
        name: "ClaimView",
        mixins: [ Form ],
        props: [ 'user' ],
        data: () => ({
            id: '',
            claim: {},
            messages: [],
            details: false,
            loading: false,
            labels: {
                message: 'Respuesta'
            },
            form: {
                img: null,
                message: ''
            },
            emojiMenu: false,
            emojis: ['🙂', '😀', '👍', '🙏', '✅', '💬', '📎', '⏱️', '🙌', '❤️', '👌', '💵'],
            lastMessageId: 0,
            modules: [
                { text: 'Wallet y saldo', value: 'Wallet' },
                { text: 'Recarga de wallet', value: 'Recharge' },
                { text: 'Retiro de wallet', value: 'Withdrawal' },
                { text: 'Transferencia o pago QR', value: 'WalletTransfer' },
                { text: 'Envio de remesa', value: 'Remittance' },
                { text: 'Cuentas bancarias', value: 'BankAccount' },
                { text: 'Identidad y documentos', value: 'Identity' },
                { text: 'Recompensas', value: 'Rewards' },
                { text: 'App, login o notificaciones', value: 'App' },
                { text: 'Seguridad', value: 'Security' },
                { text: 'Otro', value: 'Other' },
                { text: 'Deposito/Transferencia', value: 'Bank' },
                { text: 'Corresponsal/Agente', value: 'Office' },
                { text: 'Corresponsal/Agente', value: 'office' }
            ],
            view: false,
            title: null,
            img: null,
            origin: ''
        }),
        computed: {
            ticketReferenceId() {
                return this.claim.transfer_id || this.claim.payment_id || null;
            },
            ticketReferenceText() {
                return this.ticketReferenceId ? ('#' + this.ticketReferenceId) : 'Sin referencia';
            },
            ticketReferenceTitle() {
                return this.ticketReferenceId ? ('Referencia ' + this.ticketReferenceText) : this.moduleLabel(this.claim.pay_form);
            },
            ticketStatusText() {
                if (this.claim.status === 301) return 'Ticket enviado';
                if (this.claim.status === 302) return 'Respuesta recibida';
                return 'Ticket cerrado';
            },
            canSendText() {
                return String(this.form.message || '').trim().length > 0;
            }
        },
        mounted () {
            this.ini();
            this.getClaim();
            this.getOrigin();
        },
        methods: {
            ini() {
                this.id = this.$route.params.id;
            },
            moduleLabel(value) {
                const module = this.modules.find(item => item.value === value);
                return module ? module.text : (value || 'Soporte');
            },
            getClaim() {
                clearTimeout(this.timeout);
                axios.get('/api/claims/view/' + this.id)
                    .then((res) => {
                        if (res.data.v === 'success') {
                            const previousLastId = Number(this.lastMessageId || 0);
                            const messages = res.data.messages || [];
                            const latest = messages.length ? Number(messages[messages.length - 1].id || 0) : 0;
                            const hasIncoming = previousLastId > 0 && messages.some(item => {
                                return Number(item.id || 0) > previousLastId && Number(item.user_id) !== Number(this.user.id);
                            });

                            this.claim = res.data.claim;
                            this.messages = messages;
                            this.lastMessageId = latest;

                            if (hasIncoming) {
                                this.$toast.info('Tienes un nuevo mensaje en este ticket.', { icon: 'mdi-message-reply-text' });
                                this.$emit('notifications-refresh');
                            }
                        } else {
                            this.$toast.warning(res.data.status, { icon: 'mdi-information' });
                        }
                        this.$nextTick(this.scrollMessages);
                    })
                    .catch(err => {
                        if (err.response && err.response.data && err.response.data.errors) {
                            this.handleErrors(err.response.data.errors);
                        } else {
                            this.$toast.error('No fue posible cargar el ticket.', { icon: 'mdi-alert-circle' });
                        }
                    });
                this.timeout = setTimeout(this.getClaim, 10000);
            },
            sendMessage(v = 1) {
                if (v === 1 && !this.form.message) {
                    return;
                }

                this.loading = true;

                let formData = new FormData();

                formData.append('type', v === 1 ? 'Text' : 'Img');
                formData.append('img', this.form.img);
                formData.append('message',  this.form.message);

                axios.post('/api/claims/' + this.id + '/msg/send', formData,
                    {headers: {'Content-Type': 'multipart/form-data'}})
                    .then((res) => {
                        if (res.data.v === 'success') {
                            this.getClaim();
                            this.closeImg();
                            this.clearMessage();
                            this.$emit('notifications-refresh');
                            this.$toast.success(res.data.status, { icon: 'mdi-check-circle' });
                        } else {
                            this.$toast.warning(res.data.status, { icon: 'mdi-information' });
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data && err.response.data.errors) {
                            this.handleErrors(err.response.data.errors);
                        } else {
                            this.$toast.error('No fue posible enviar la respuesta.', { icon: 'mdi-alert-circle' });
                        }
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            onFileChanged(img) {
                let input = img.target.files[0];

                if (input) {
                    const reader = new FileReader;
                    reader.onload = e => {
                        this.img = e.target.result;
                    };
                    reader.readAsDataURL(input);
                }
                this.form.img = input;
                this.view = true;
            },
            senderLabel(msg) {
                return Number(msg.user_id) === Number(this.user.id) ? (msg.name + ' (Tu)') : msg.name;
            },
            messageRowClass(msg) {
                return Number(msg.user_id) === Number(this.user.id) ? 'ticket-message-row--own' : 'ticket-message-row--other';
            },
            messageBubbleClass(msg) {
                return Number(msg.user_id) === Number(this.user.id) ? 'ticket-bubble--own' : 'ticket-bubble--other';
            },
            appendEmoji(emoji) {
                this.form.message = String(this.form.message || '') + emoji;
                this.clearErrors('message');
                this.emojiMenu = false;
            },
            scrollMessages() {
                const box = this.$refs.messageList;
                const el = box && box.$el ? box.$el : box;

                if (el) {
                    el.scrollTop = el.scrollHeight;
                }
            },
            getImg(id) {
                const items = this.messages;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.img = '/' + items[i].text;
                    }
                }
                this.view = true;
            },
            closeImg() {
                if (this.$refs.uploader) {
                    this.$refs.uploader.value = null;
                }
                this.img = null;
                this.form.img = null;
                this.view = false;
            },
            clearMessage() {
                this.form.message = '';
                if (this.$refs.form && this.$refs.form.resetValidation) {
                    this.$refs.form.resetValidation();
                }
            },
            openClaim(id) {
                this.$swal({
                    title: '¿Esta seguro que desea reabrir este ticket?',
                    type: 'warning',
                    confirmButtonText: 'Si, reabrir',
                    cancelButtonText: 'No, cancelar'
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;

                        axios.get('/api/claims/open/' + id).then((res) => {
                            if (res.data.v === 'success') {
                                this.getClaim();
                                this.$toast.success(res.data.status, {icon: 'check-circle'});
                            } else {
                                this.$toast.error(res.data.status, {icon: 'mdi-close-circle'});
                            }
                        }).catch(err => {
                            if (err.response && err.response.data && err.response.data.errors) {
                                this.handleErrors(err.response.data.errors);
                            } else {
                                this.$toast.error('No fue posible reabrir el ticket.', { icon: 'mdi-alert-circle' });
                            }
                        });
                    }
                });
            },
            closeClaim(id) {
                this.$swal({
                    title: '¿Esta seguro que desea cerrar este ticket?',
                    type: 'warning',
                    confirmButtonText: 'Si, cerrar',
                    cancelButtonText: 'No, cancelar'
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;

                        axios.get('/api/claims/close/' + id).then((res) => {
                            if (res.data.v === 'success') {
                                this.getClaim();
                                this.$toast.success(res.data.status, {icon: 'check-circle'});
                            } else {
                                this.$toast.error(res.data.status, {icon: 'mdi-close-circle'});
                            }
                        }).catch(err => {
                            if (err.response && err.response.data && err.response.data.errors) {
                                this.handleErrors(err.response.data.errors);
                            } else {
                                this.$toast.error('No fue posible cerrar el ticket.', { icon: 'mdi-alert-circle' });
                            }
                        });
                    }
                });
            }
        },
        destroyed() {
            clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>
.ticket-chat-card {
    display: flex;
    flex-direction: column;
    min-height: 620px;
}

.ticket-chat-header {
    flex: 0 0 auto;
}

.ticket-chat-body {
    flex: 1 1 auto;
    height: 460px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 14px 12px;
}

.ticket-message-row {
    align-items: flex-end;
    display: flex;
    margin-bottom: 12px;
}

.ticket-message-row--own {
    flex-direction: row-reverse;
}

.ticket-message-avatar {
    border: 1px solid rgba(13, 147, 165, 0.25);
    flex: 0 0 auto;
    margin: 0 8px;
}

.ticket-message-content {
    max-width: min(78%, 420px);
}

.ticket-message-row--own .ticket-message-content {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
}

.ticket-message-meta {
    color: var(--v-disabled-base);
    margin-bottom: 4px;
}

.ticket-bubble {
    border-radius: 8px;
    line-height: 1.4;
    padding: 10px 12px;
    white-space: pre-wrap;
    word-break: break-word;
}

.ticket-bubble--own {
    background: var(--v-primary-base);
    color: var(--v-secondary-base);
}

.ticket-bubble--other {
    background: rgba(13, 147, 165, 0.1);
    color: var(--v-primary-base);
}

.ticket-message-image {
    border: 1px solid rgba(13, 147, 165, 0.18);
    border-radius: 8px;
    cursor: pointer;
    overflow: hidden;
}

.ticket-chat-composer {
    flex: 0 0 auto;
    padding: 10px 12px;
}

.ticket-form {
    width: 100%;
}

.ticket-composer-row {
    align-items: flex-end;
    display: flex;
    gap: 6px;
    width: 100%;
}

.emoji-picker {
    max-width: 236px;
}

.emoji-option {
    font-size: 20px;
    line-height: 1;
}

@media (max-width: 600px) {
    .ticket-chat-card {
        min-height: calc(100vh - 168px);
    }

    .ticket-chat-body {
        height: calc(100vh - 310px);
        min-height: 320px;
    }

    .ticket-message-content {
        max-width: 82%;
    }

    .ticket-message-avatar {
        height: 34px !important;
        margin: 0 6px;
        min-width: 34px !important;
        width: 34px !important;
    }

    .ticket-chat-composer {
        bottom: 0;
        position: sticky;
        z-index: 2;
    }
}
</style>
